import { useScrollReveal } from '@/hooks/useScrollReveal';
import { howWeWorkSteps } from '@/mocks/stats';

export default function HowWeWork() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="w-full py-16 md:py-24 bg-ivory-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={ref}
          className={`text-center mb-10 md:mb-14 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
            Our Process
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-charcoal-300">
            How We Work
          </h2>
          <p className="text-sm md:text-base text-charcoal-50 mt-3 max-w-lg mx-auto">
            A simple, transparent six-step process designed to make your property investment effortless.
          </p>
        </div>

        {/* Timeline - Desktop Horizontal / Mobile Vertical */}
        <div className="relative max-w-5xl mx-auto">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-[40px] left-[10%] right-[10%] h-0.5 bg-ivory-300" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6 lg:gap-4">
            {howWeWorkSteps.map((step, index) => (
              <div
                key={step.id}
                className={`flex flex-col items-center text-center group ${
                  isVisible ? 'animate-fade-in-up' : 'opacity-0'
                }`}
                style={{ animationDelay: `${0.1 + index * 0.12}s` }}
              >
                {/* Icon Circle */}
                <div className="relative w-16 h-16 md:w-[72px] md:h-[72px] flex items-center justify-center rounded-full bg-white border-4 border-ivory-200 group-hover:border-brand-orange group-hover:bg-brand-orange group-hover:text-white transition-all duration-500 shadow-md z-10 shrink-0">
                  <i className={`${step.icon} text-xl md:text-2xl text-brand-orange group-hover:text-white transition-colors`} />
                  <div className="absolute -top-1 -right-1 w-6 h-6 flex items-center justify-center rounded-full bg-brand-orange text-white text-xs font-bold">
                    {step.id}
                  </div>
                </div>

                {/* Content */}
                <div className="mt-4 lg:mt-6">
                  <h3 className="text-sm md:text-base font-bold text-charcoal-300 mb-1">
                    {step.title}
                  </h3>
                  <p className="text-xs md:text-sm text-charcoal-50 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}